export default "__VITE_ASSET__TMfgOHMF__"